var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoosterIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000005288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 10,
    rx: 3,
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M7.64458 2H3C2.44772 2 2 2.44772 2 3V7C2 7.55228 2.44772 8 3 8H7.64458V6.4L9.89894 7.6H11V2.4H9.89894L7.64458 3.4V2Z",
    fill: "var(--fill-0, #6262D7)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoosterIcon);
export default __webpack_public_path__ + "static/media/booster-icon.4d79bda28cac18244ae9de356ddd8e06.svg";
export { ForwardRef as ReactComponent };